import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogTitle, Typography, TextField, DialogActions, Button, CircularProgress, InputLabel, Autocomplete, createFilterOptions } from "@mui/material";
import { useGetBinGroupsQuery } from "../../../../../../shell/services/mediaManager";
import { Group } from "../../../../../../shell/services/types";
interface Props {
  handleGroupChange: (newGroupId: string) => void;
  onClose?: () => void;
  binId: string;
  fileCount?: number;
  showSpinner?: boolean;
}
export const MoveFileDialog = ({
  handleGroupChange,
  onClose,
  binId,
  fileCount,
  showSpinner
}: Props) => {
  const {
    t
  } = useTranslation();
  const {
    data: binGroups
  } = useGetBinGroupsQuery(binId);
  const [selectedGroup, setSelectedGroup] = useState<Group | null>({
    name: "None",
    bin_id: binId,
    group_id: binId,
    id: binId
  });
  const sortedBinGroups = useMemo(() => {
    if (!binGroups) return [];
    return [...binGroups].sort((a, b) => a?.name?.localeCompare(b?.name));
  }, [binGroups]);
  return <Dialog open={true} fullWidth maxWidth={"xs"} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="MoveFileDialog" data-sentry-source-file="MoveFileDialog.tsx">
      <DialogTitle component="div" data-sentry-element="DialogTitle" data-sentry-source-file="MoveFileDialog.tsx">
        <Typography fontWeight={600} variant="h5" data-sentry-element="Typography" data-sentry-source-file="MoveFileDialog.tsx">
          {fileCount > 1 ? t("media.moveFileDialogTitleMultiple", {
          count: fileCount
        }) : t("media.moveFileDialogTitleSingle")}
        </Typography>
      </DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="MoveFileDialog.tsx">
        <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="MoveFileDialog.tsx">{t("media.moveFileDialogDestinationLabel")}</InputLabel>
        <Autocomplete size="small" fullWidth value={selectedGroup} disableClearable options={binGroups ? [{
        name: "None",
        bin_id: binId,
        group_id: binId,
        id: binId
      }, ...sortedBinGroups] : []} renderInput={params => <TextField {...params} hiddenLabel />} renderOption={(props, option) => <li {...props} key={option.id}>
              {option.name}
            </li>} getOptionLabel={(option: any) => option.name} filterOptions={createFilterOptions({
        stringify: option => option.name
      })} isOptionEqualToValue={(option, value) => option.id === value.id} onChange={(event, newValue) => setSelectedGroup(newValue as Group)} data-sentry-element="Autocomplete" data-sentry-source-file="MoveFileDialog.tsx" />
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="MoveFileDialog.tsx">
        <Button color="inherit" onClick={() => onClose()} disabled={showSpinner} data-sentry-element="Button" data-sentry-source-file="MoveFileDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button variant="contained" onClick={() => {
        handleGroupChange(selectedGroup.id);
      }} data-sentry-element="Button" data-sentry-source-file="MoveFileDialog.tsx">
          {showSpinner ? <CircularProgress size="24px" color="inherit" /> : t("media.moveFileDialogMoveButton")}
        </Button>
      </DialogActions>
    </Dialog>;
};